var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"p-3",staticStyle:{"text-align":"center"},on:{"click":_vm.goHome}},[_c('h2',[_vm._v("Search Anime")])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }